import { Ticket } from '@/services/ticketsService';
import { WeighingTicketData } from '@/components/WeighingTicket';
import { convertPeseeToTicketData } from './ticketDataConverter';

/**
 * Convertit un objet Ticket en WeighingTicketData pour les composants
 * Utilise maintenant la fonction centralisée convertPeseeToTicketData
 */
export const convertTicketToWeighingTicketData = (ticket: Ticket): WeighingTicketData => {
  // Convertir le Ticket en format compatible avec convertPeseeToTicketData
  // Un Ticket est essentiellement une Pesée, donc on peut le passer directement
  return convertPeseeToTicketData(ticket as any);
};

/**
 * Récupère la référence d'un ticket (gère les deux formats)
 */
export const getTicketReference = (ticket: Ticket): string => {
  return (ticket as any).référence || ticket.reference || `#${ticket.id}`;
};
